// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__MuNKU","fadeIn":"Logo_fadeIn__ep3x7"};